import { render } from "./DesktopCategories.vue?vue&type=template&id=04b6efde&scoped=true"
import script from "./DesktopCategories.vue?vue&type=script&lang=js"
export * from "./DesktopCategories.vue?vue&type=script&lang=js"

import "./DesktopCategories.vue?vue&type=style&index=0&id=04b6efde&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/www/releases/20260911022515/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04b6efde"]])

export default __exports__